import React from "react";
import useQuery from "./useQuery";

export interface Group {
  title: string | null;
  startDate: number;
  endDate: number;
  nextStartDate: number | null;
  i?: number;
  endedByNull: boolean;
}

function useGroups(projectId: string) {
  const groups = useQuery("/projects/:projectId(uuid)/groups", { routeParams: { projectId } }).body;

  return React.useMemo(
    () =>
      groups.map((group, index) => {
        let nextStartDate = null;
        let endedByNull = false;
        if (index < groups.length - 1) {
          const nextGroup = groups[index + 1];
          if (nextGroup === undefined) throw new Error("should not happen");
          nextStartDate = new Date(nextGroup.startsAt).getTime();
          endedByNull = nextGroup.group === null;
        }

        return {
          title: group.group,
          startDate: new Date(group.startsAt).getTime(),
          endDate: new Date(group.endsAt).getTime(),
          nextStartDate,
          endedByNull,
          i: index,
        };
      }),
    [groups],
  );
}

export default useGroups;
